import {SkinType} from 'gabi-api-ts/v2/common/enums/enums';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';

import patientAvatar_skinType_0 from '@/public/images/baby_avatar_skin_0.svg';
import patientAvatar_skinType_1 from '@/public/images/baby_avatar_skin_1.svg';
import patientAvatar_skinType_2 from '@/public/images/baby_avatar_skin_2.svg';
import patientAvatar_skinType_3 from '@/public/images/baby_avatar_skin_3.svg';
import patientAvatar_skinType_4 from '@/public/images/baby_avatar_skin_4.svg';
import patientAvatar_skinType_5 from '@/public/images/baby_avatar_skin_5.svg';
import patientAvatar_skinType_6 from '@/public/images/baby_avatar_skin_6.svg';
import {SilhouetteIcon} from '@/components/static/silhouette-icon.tsx';
import {colorPalette} from '@/themes/darkmode';

const patientPicSkinType: Record<number, string> = {
    0: patientAvatar_skinType_0,
    1: patientAvatar_skinType_1,
    2: patientAvatar_skinType_2,
    3: patientAvatar_skinType_3,
    4: patientAvatar_skinType_4,
    5: patientAvatar_skinType_5,
    6: patientAvatar_skinType_6,
};

type PatientAvatarProps = {
    skinType: SkinType;
    isAdult?: boolean;
};

const PatientAvatar = ({skinType, isAdult}: PatientAvatarProps) => {
    const { t } = useTranslation();

    if (isAdult) {
        return (
            <span style={{width: 50, textAlign: 'center', display: 'inline-block'}}>
                <SilhouetteIcon color={colorPalette.skinColor[skinType] ?? colorPalette.skinColor[0]} size={32}/>
            </span>
        );
    }
    else {
        return (
            <img
                src={patientPicSkinType[skinType]}
                width={50}
                alt={t('pages.patients.alt') ??''}
            />
        );
    }
};

PatientAvatar.propTypes = {
    skinType: PropTypes.any,
};

export {PatientAvatar};
